import { ExternalLink, Heart } from "lucide-react";

const ORGS = [
  {
    name: "Nadia's Initiative",
    desc: "Founded by Nobel Peace Prize laureate Nadia Murad to advocate for survivors of sexual violence and rebuild Sinjar.",
    url: "https://www.nadiasinitiative.org/",
    testid: "org-nadias-initiative",
  },
  {
    name: "Yazda",
    desc: "A global Yazidi-led organization providing humanitarian relief, mental-health care for survivors, and documentation for prosecutions.",
    url: "https://www.yazda.org/",
    testid: "org-yazda",
  },
  {
    name: "Free Yezidi Foundation",
    desc: "Survivor-centric programs in Iraqi camps: trauma therapy, women's centers, livelihoods, and accountability work.",
    url: "https://www.freeyezidi.org/",
    testid: "org-free-yezidi",
  },
  {
    name: "UNITAD — UN Investigative Team",
    desc: "The UN team that gathered evidence of ISIS crimes against Yazidis to support fair prosecutions worldwide.",
    url: "https://www.unitad.un.org/",
    testid: "org-unitad",
  },
  {
    name: "UNHCR — Refugees in Iraq",
    desc: "Supports hundreds of thousands of displaced Yazidis still living in camps in the Kurdistan Region of Iraq.",
    url: "https://www.unhcr.org/countries/iraq",
    testid: "org-unhcr",
  },
];

export const TakeAction = () => {
  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-12 py-24 lg:py-32" data-testid="act-page">
      <div className="overline text-[#D4AF37]">Justice is unfinished</div>
      <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#F2EBE5] mt-4 leading-tight max-w-3xl">
        Remembrance is the beginning. Action carries it forward.
      </h1>
      <p className="text-[#A19D98] mt-6 max-w-2xl leading-relaxed">
        Every organization below is verified, survivor-centric, and working
        today on relief, justice, and the search for the missing. Consider
        supporting them with a donation, a share, or your professional skills.
      </p>

      <div className="mt-16 grid md:grid-cols-2 gap-px bg-white/5">
        {ORGS.map((o) => (
          <a
            key={o.testid}
            href={o.url}
            target="_blank"
            rel="noreferrer noopener"
            data-testid={o.testid}
            className="bg-[#0A0A0C] p-10 hover:bg-[#111215] group transition-colors duration-500 flex flex-col"
          >
            <div className="flex items-start justify-between">
              <h3 className="font-serif-display text-2xl text-[#F2EBE5] group-hover:text-[#D4AF37] transition-colors duration-500">
                {o.name}
              </h3>
              <ExternalLink className="w-4 h-4 text-[#6E6B67] group-hover:text-[#D4AF37] transition-colors duration-500" strokeWidth={1.5} />
            </div>
            <p className="text-sm text-[#A19D98] mt-5 leading-relaxed flex-1">{o.desc}</p>
            <div className="overline mt-8 text-[#D4AF37] inline-flex items-center gap-2">
              Visit website
            </div>
          </a>
        ))}
      </div>

      <div className="mt-24 border border-white/10 p-10 bg-[#111215]" data-testid="act-more">
        <Heart className="w-5 h-5 text-[#D4AF37] mb-4" strokeWidth={1.25} />
        <h3 className="font-serif-display text-2xl text-[#F2EBE5]">Other things you can do</h3>
        <ul className="text-sm text-[#A19D98] mt-6 space-y-3 leading-relaxed list-disc list-inside">
          <li>Share survivor voices — not just statistics — on your social platforms.</li>
          <li>Ask your representatives to support the search for the 2,700 still missing.</li>
          <li>If you are a journalist, lawyer, or therapist — many of these organizations need pro-bono help.</li>
          <li>Read Nadia Murad&apos;s <em>The Last Girl</em>. Recommend it to one person this month.</li>
          <li>Mark August 3 each year. Remembrance is an act.</li>
        </ul>
      </div>
    </div>
  );
};

export default TakeAction;
